import * as React from "react";
import {Condition} from "./AdvancedSearchControls";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {ConditionBase} from "./Conditions/ConditionBase";
import {NoneCondition} from "./Conditions/NoneCondition";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimesCircle} from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import {faMinusCircle} from "@fortawesome/free-solid-svg-icons/faMinusCircle";
import {faPlusCircle} from "@fortawesome/free-solid-svg-icons/faPlusCircle";

export class SearchItem extends React.Component<SearchItemProps, SearchItemState> {
    static defaultProps: Partial<SearchItemProps> = {};

    constructor(props: SearchItemProps) {
        super(props);
        this.state = {};
    }

    public render() {

        let condition=this.props.Fields.find(x=>x.Options.Id==this.props.Condition.FieldId);
        if(condition==null)
            condition=new NoneCondition(null);

        let comparisons=condition.GetComparisons();
        return (
            <tr>
                <td style={{width:'40%',verticalAlign:'top'}}>
                    <SearchableSelect Value={this.props.Condition.FieldId} onChange={x=>{this.props.Condition.FieldId=x;this.props.FieldChanged();this.forceUpdate()}}>
                        {this.props.Fields.map(x=>
                            <option value={x.Options.Id}>{x.Options.Label} <span style={{color:'#a0a0a0',fontStyle:'italic'}}>({x.Options.Id})</span></option>
                        )}
                    </SearchableSelect>
                </td>
                <td style={{width:'20%',verticalAlign:'top'}}>
                    <SearchableSelect Value={this.props.Condition.Comparison} disabled={comparisons.length==0} onChange={x=>{this.props.Condition.Comparison=x;this.forceUpdate();}}>
                        {comparisons.map(x=>
                            <option value={x.Value}>{x.Label}</option>
                        )}
                    </SearchableSelect>
                </td>
                <td style={{width:'calc(40% - 80px)',verticalAlign:'top'}}>
                    {condition.GetValueEditor(this.props.Condition,()=>this.forceUpdate())}
                </td>
                <td style={{width:80,cursor:"pointer"}}>
                    <div>

                        <span style={{fontSize:20,marginRight:5}} className={'rnRemove'} onClick={()=>this.props.Add()}>
                            <FontAwesomeIcon icon={faPlusCircle}/>
                        </span>

                        <span style={{fontSize:20}} className={'rnRemove'} onClick={()=>this.props.Remove()}>
                            <FontAwesomeIcon icon={faMinusCircle}/>
                        </span>
                    </div>
                </td>
            </tr>
        )
    }


}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface SearchItemProps {
    Fields:ConditionBase[];
    Condition:Condition;
    FieldChanged:()=>void;
    Remove:()=>void;
    Add:()=>void;
}

interface SearchItemState {

}

//#endregion "My Region"